/**
 * Emil Kowalski-style motion presets.
 * Rules:
 *  - transform + opacity ONLY (no width/height/color transitions on layout)
 *  - snappy durations (0.2–0.6s)
 *  - subtle y/scale (y: 8–24, scale: 0.97–1)
 *  - matched easing curve everywhere
 */

// Signature ease — smooth, snappy exit
export const EASE_OUT = [0.22, 1, 0.36, 1];
// Snappy micro-interaction ease (Vercel/Radix-esque)
export const EASE_SNAP = [0.32, 0.72, 0, 1];

// Fade + rise, staggered — for section reveals
export const fadeUp = (delay = 0, y = 18) => ({
  initial: { opacity: 0, y, filter: "blur(6px)" },
  whileInView: { opacity: 1, y: 0, filter: "blur(0px)" },
  viewport: { once: true, margin: "-8% 0px -8% 0px" },
  transition: { duration: 0.55, ease: EASE_OUT, delay },
});

// Softer subtle card lift
export const fadeUpSubtle = (delay = 0) => ({
  initial: { opacity: 0, y: 10, scale: 0.985 },
  whileInView: { opacity: 1, y: 0, scale: 1 },
  viewport: { once: true, margin: "-6% 0px -6% 0px" },
  transition: { duration: 0.45, ease: EASE_OUT, delay },
});

// Pop reveal for tiles / metrics
export const popIn = (delay = 0) => ({
  initial: { opacity: 0, y: 14, scale: 0.97 },
  whileInView: { opacity: 1, y: 0, scale: 1 },
  viewport: { once: true, margin: "-10% 0px" },
  transition: { duration: 0.5, ease: EASE_OUT, delay },
});

// Parent stagger container
export const staggerParent = (gap = 0.06, delay = 0) => ({
  initial: {},
  whileInView: { transition: { staggerChildren: gap, delayChildren: delay } },
  viewport: { once: true, margin: "-8% 0px" },
});

// Line-by-line masked reveal (used with a wrapper that has overflow-hidden per line)
export const maskLine = (delay = 0) => ({
  initial: { y: "110%", opacity: 0 },
  animate: { y: "0%", opacity: 1 },
  transition: { duration: 0.9, delay, ease: EASE_OUT },
});
